var heading_default = {
  "fontElementMap": "B3KlP",
  "elementSpacing": "_32njD",
  "headerOne": "unkYU _32njD",
  "headerTwo": "Me8pq _32njD",
  "headerThree": "fYinK _32njD",
  "headerFour": "OayMb _32njD",
  "headerFive": "DhT1Z _32njD",
  "headerSix": "wPvHz _32njD",
  "child": "e4Wvi"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
